import BookingForm from './components/BookingForm';
import PreviewTable from './components/PreviewTable';
import logo from './img/lws-logo.svg';
import './styles.css';

function App() {
  return (
    <>
      <header id="header">
        <div className="container">
          <img src={logo} alt="logo" className="logo" />
          <div className="flex items-center">
            <a className="text-white min-w-[50px] font-medium" href="/">Home</a>
            <button className="log-btn btn">Login</button>
          </div>
        </div>
      </header>


      <section>
        {/* <!-- Input Data --> */}
        <BookingForm/>

        {/* <!-- Preview Data --> */}
        <PreviewTable/>
      </section>
    </>
  );
}

export default App;
